<template>
  <div>
    <v-app-bar
      dense
      flat
    >
      <v-tabs
        v-model="selectedTab"
      >
        <v-tabs-slider color="primary" />
        <v-tab
          v-for="tab in tabs"
          :key="tab.name"
        >
          {{ tab.name }}
        </v-tab>
      </v-tabs>
    </v-app-bar>
    <v-card
      flat
      outlined
      tile
    >
      <v-tabs-items v-model="selectedTab">
        <v-tab-item
          v-for="tab in tabs"
          :key="tab.name"
        >
          <component :is="tab.component" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import Releases from "./Releases";
import DigitoryApps from "./DigitoryApps";

export default {
  name: "Apps",
	components: {
    Releases,
    DigitoryApps
	},
	data() {
		return {
			loader: false,
			selectedTab: 0,
			tabs: [
				{
					name: "Releases",
					component: "releases"
				},
				{
					name: "Digitory Apps",
					component: "digitoryApps"
				}
			]
		};
	}
};
</script>
